import { Grid, InputAdornment, TextField } from '@mui/material';
import React, { useContext } from 'react';
import { ISearchForm } from '../../../interfaces/bookingContext';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { TicketCoupon } from '@vectopus/atlas-icons-react';

const SetCouponField = (props: any) => {
  const useStyles = makeStyles()((theme) => {
    return {
      couponField: {
        backgroundColor: '#f0f0f0',
        position: 'relative',
        alignItems: 'normal',
        minHeight: 58,
        justifyContent: 'center',
        borderRadius: theme.radius.formBorderRadius,
        [theme.breakpoints.down('md')]: {
          backgroundColor: '#FFF',
          '.MuiInputBase-root': {
            width: '100%!important'
          }
        },
        '.MuiInputBase-root': {
          /*paddingRight: '32px',*/
          border: 'none!important',
          fontSize: 14,
          /*input: {
            padding: '0 24px'
          },*/
          'i::before': {
            color: '#000'
          },
          fieldset: {
            border: 'none'
          }
        }
      },
      couponField2: {
        backgroundColor: '#f5f5f5',
        height: '58px!important',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          '.MuiInputBase-root': {
            border: 'none!important',
            width: '100%!important',
            paddingLeft: '4px!important'
          },
          svg: {
            display: 'none'
          }
        }
      }
    };
  });

  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleCouponChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    /*appContext.resetAvailability();*/
    appContext.setUpdateSearch(true);
    /*appContext.searchForms[appContext.orderIndex].status = 'to_start';*/
    const clone: ISearchForm[] = [...appContext.searchForms];
    clone[0].Coupon = event.target.value.toString().replace(/^\uFEFF/, '').trim().toUpperCase();
    appContext.setSearchForms(clone);
  };

  const container = props.params.container;

  return (
    <Grid size={{ xs: 12, sm: 12, md: 2, lg: 3 }} id={'promoCode'}>
      {
        container === 'DrawerSearchWidget' ? (
          <TextField
            variant={'outlined'}
            name={'Coupon'}
            placeholder={t('Coupon')}
            value={appContext.searchForms[appContext.orderIndex].Coupon}
            onChange={handleCouponChange}
            className={container === 'SearchBarMobile' ? classes.couponField2 : classes.couponField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <TicketCoupon size={18} />
                </InputAdornment>
              )
            }}
          />
        ) : (
          <TextField
            variant={'outlined'}
            name={'Coupon'}
            placeholder={t('Coupon')}
            value={appContext.searchForms[appContext.orderIndex].Coupon}
            onChange={handleCouponChange}
            className={container === 'SearchBarMobile' ? classes.couponField2 : classes.couponField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <TicketCoupon size={18} />
                </InputAdornment>
              )
            }}
          />
        )
      }
    </Grid>
  );
};

export default SetCouponField;
